import { Injectable } from '@angular/core';
import { UserService } from '@app/core/services/user.service';
import { Agency } from '@app/models';
import * as AgencyActions from '@app/pcs/actions/agency-display-settings';
import { AgencyDisplaySettingsActionTypes } from '@app/pcs/actions/agency-display-settings';
import { AgencyDataService } from '@app/pcs/services/agency-data.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mapPayload } from '@util';
import { exhaustMap, map } from 'rxjs/operators';

@Injectable()
export class AgencyDisplaySettingsEffects {

  updateAgencyDisplaySettings$ = createEffect(() => this.actions$.pipe(
    ofType<AgencyActions.UpdateAgencyDisplaySettings>(AgencyDisplaySettingsActionTypes.UpdateAgencyDisplaySettings),
    mapPayload(),
    exhaustMap(({agency}: { agency: Agency }) =>
      this.agencyRestService.updateAgencyDisplaySettings(agency).pipe(
        map((updatedAgency: Agency) => this.userService.updateAgency(updatedAgency))
      )
    )
  ), {dispatch: false});

  constructor(private actions$: Actions,
    private agencyRestService: AgencyDataService,
    private userService: UserService) {
  }
}
